import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EmailVerificationType } from 'queries';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '20px', marginBottom: '25px' },
  lock: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  verifyEmail: { marginTop: '2vh' },
  headingBox: { textAlign: 'center' },
}));

type Props = {
  verificationType: EmailVerificationType;
  showIcon?: boolean;
};

const Banner = ({ verificationType, showIcon }: Props) => {
  const classes = useStyles();

  const icon = getIcon();
  const title = getTitle();
  const description = getDescription();

  function getIcon() {
    let icon = null;

    switch (verificationType) {
      case EmailVerificationType.UserRegistration:
      case EmailVerificationType.UserPortalInvitationNewUser:
      case EmailVerificationType.UserPortalInvitationExistingUser:
      case EmailVerificationType.UserPortalInvitationNewClient:
        icon = <img src={'/lock.svg'} alt="Trustate Lock" className={classes.lock} />;
        break;

      case EmailVerificationType.EstateClientConsentTruadmin:
      case EmailVerificationType.EstateClientConsentTruplanning:
      case EmailVerificationType.EstateClientConsentTruproxy:
      case EmailVerificationType.EstateClientConsentTrustadmin:
        icon = <img src="/checkmark-icon.svg" alt="Success!"></img>;
        break;
    }

    return icon;
  }

  function getTitle() {
    let title = '';

    switch (verificationType) {
      case EmailVerificationType.UserRegistration:
        title = 'Verify your email';
        break;

      case EmailVerificationType.UserPortalInvitationNewUser:
      case EmailVerificationType.UserPortalInvitationNewClient:
        title = 'Verify your email and set a password';
        break;

      case EmailVerificationType.UserPortalInvitationExistingUser:
        title = 'Verify your email and password';
        break;

      case EmailVerificationType.EstateClientConsentTruadmin:
      case EmailVerificationType.EstateClientConsentTruplanning:
      case EmailVerificationType.EstateClientConsentTruproxy:
        title = 'Estate client consent';
        break;
      case EmailVerificationType.EstateClientConsentTrustadmin:
        title = 'Trust client consent';
        break;

      default:
        title = 'Invalid verification type';
        break;
    }

    return title;
  }

  function getDescription() {
    let description = '';

    switch (verificationType) {
      case EmailVerificationType.UserRegistration:
        description = 'Enter the verification code that was sent to you.';
        break;

      case EmailVerificationType.UserPortalInvitationNewUser:
      case EmailVerificationType.UserPortalInvitationExistingUser:
      case EmailVerificationType.UserPortalInvitationNewClient:
      case EmailVerificationType.EstateClientConsentTruadmin:
      case EmailVerificationType.EstateClientConsentTruplanning:
      case EmailVerificationType.EstateClientConsentTruproxy:
      case EmailVerificationType.EstateClientConsentTrustadmin:
        description = ''; // no description necessary
        break;

      default:
        description = 'Invalid verification type';
        break;
    }

    return description;
  }

  return (
    <div className={classes.headingBox}>
      <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      {showIcon && icon}
      <div className={classes.verifyEmail}>
        <Typography variant="h4" style={{ marginBottom: '15px' }}>
          {title}
        </Typography>
        {description && (
          <Typography style={{ display: 'inline', paddingLeft: '10px', paddingRight: '10px' }}>
            {description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default Banner;
